module.exports = __webpack_public_path__ + "static/img/pink-sphere-120.93d28af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pink-sphere-120.png
// module id = O4en
// module chunks = 1